import {
  ASSET_FILE_REQUIREMENT_COLLECTION,
  ASSET_FORM_REQUIREMENT_COLLECTION,
  FILE_REQUIREMENT_COLLECTION,
  FORM_REQUIREMENT_COLLECTION,
} from './config';


export function getIsFileReq(collection) {
  return collection === FILE_REQUIREMENT_COLLECTION || collection === ASSET_FILE_REQUIREMENT_COLLECTION;
}

export function getIsFormReq(collection) {
  return collection === FORM_REQUIREMENT_COLLECTION || collection === ASSET_FORM_REQUIREMENT_COLLECTION;
}

export const canEditChildProp = model => model ? !model.requirement : true;



// WEBPACK FOOTER //
// ./src/js/requirements/domain/utils.js